import IndicatorApi from '../services/indicator.js';
import BarChart from '../components/charts/BarChart';
import LineChart from '../components/charts/LineChart';
import DoughnutChart from '../components/charts/DoughnutChart.vue';

export default {
  components: {
    BarChart,
    LineChart,
    DoughnutChart,
  },
  props: {
    userid: {
      type: [Number, String],
    },
    year: {
      type: Number,
    },
    type: {
      type: String,
    },
    startMonth: {
      type: Number,
      default: 1,
    },
    endMonth: {
      type: Number,
      default: 12,
    },
  },
  data() {
    return {
      options: {
        legend: {
          labels: {
            fontSize: 10,
            usePointStyle: true,
          },
        },
        responsive: true,
        maintainAspectRatio: false,
      },
      showedPeriod: {
        year: this.year,
        startMonth: this.startMonth,
        endMonth: this.endMonth,
      },
      drawing: false,
    };
  },
  async mounted() {
    this.drawAgain();
  },
  methods: {
    chartFormat: function(format) {
      this.myType = format;
    },
    drawAgain() {
      this.drawing = true;
      if (this.type) {
        console.log(this.type);
        this.myType = this.type;
      }
      IndicatorApi['get' + this.indicator](
        this.userid,
        this.year,
        this.startMonth,
        this.endMonth,
      ).then(res => {
        console.log('INDICATOR:', res);
        this.mydata = res.data;
        this.drawing = false;
        this.updateShowedPeriod();
      });
    },
    updateShowedPeriod() {
      this.showedPeriod = {
        year: this.year,
        startMonth: this.startMonth,
        endMonth: this.endMonth,
      };
      this.$emit('showedperiod', this.showedPeriod);
    },
  },

  computed: {
    noData() {
      let sum = 0;

      if (this.mydata) {
        this.mydata.datasets.forEach(dataset => {
          dataset.data.forEach(data => {
            sum = Number(sum) + Number(data);
          });
        });
      }

      return sum === 0;
    },
  },
  watch: {
    year: function(val, oldVal) {
      if (
        this.year &&
        ((this.startMonth && this.endMonth) || (!this.startMonth && !this.endMonth))
      ) {
        this.drawAgain();
      }
    },
    startMonth: function(val, oldVal) {
      if (
        this.year &&
        ((this.startMonth && this.endMonth) || (!this.startMonth && !this.endMonth))
      ) {
        this.drawAgain();
      }
    },
    endMonth: function(val, oldVal) {
      if (
        this.year &&
        ((this.startMonth && this.endMonth) || (!this.startMonth && !this.endMonth))
      ) {
        this.drawAgain();
      }
    },
  },
};
